import React, {MouseEvent} from 'react';
import {t} from '@lingui/core/macro';

import MoreActionsItem from 'shared/ui/MoreActions/MoreActionsItem';
import MoreActionsDots from 'shared/ui/MoreActions/MoreActionsDots';
import Suspend from 'shared/ui/icons/General/Suspend';
import TurnOn from 'shared/ui/icons/General/TurnOn';
import Edit from 'shared/ui/icons/General/Edit';
import MoreDetailed from 'shared/ui/icons/General/MoreDetailed';
import Journal from 'shared/ui/icons/TablesMenu/Journal';
import Delete from 'shared/ui/icons/General/Delete';
import Tags from 'shared/ui/icons/TablesMenu/Tags';
import Check from 'shared/ui/icons/TablesMenu/Check';

type ClickHandler = (_event: MouseEvent) => void;

interface IMonitorMenuProps {
    isActive: boolean,
    showToggle?: boolean,
    onCheckClick?: ClickHandler,
    onPauseClick: ClickHandler,
    onResumeClick: ClickHandler,
    onEditClick: ClickHandler,
    onTagsClick: ClickHandler,
    onDetailsClick: ClickHandler,
    onLogClick?: ClickHandler,
    onDeleteClick: ClickHandler,
}

const MonitorMenu: React.FC<IMonitorMenuProps> = ({
    isActive,
    showToggle = true,
    onCheckClick,
    onPauseClick,
    onResumeClick,
    onEditClick,
    onTagsClick,
    onDetailsClick,
    onLogClick,
    onDeleteClick,
}) => (
    <MoreActionsDots placement="auto">
        {onCheckClick && (
            <MoreActionsItem
                key="check"
                label={t`Проверить`}
                icon={<Check/>}
                onClick={onCheckClick}
            />
        )}
        {showToggle && (isActive
            ? <MoreActionsItem
                key="off"
                label={t`На паузу`}
                icon={<Suspend/>}
                onClick={onPauseClick}
                data-modal-trigger="true"
            />
            : <MoreActionsItem
                key="on"
                label={t`Включить`}
                icon={<TurnOn/>}
                onClick={onResumeClick}
                data-modal-trigger="true"
            />
        )}
        <MoreActionsItem
            key="edit"
            label={t`Редактировать`}
            icon={<Edit/>}
            onClick={onEditClick}
            data-modal-trigger="true"
        />
        <MoreActionsItem
            key="tags"
            label={t`Теги`}
            icon={<Tags/>}
            onClick={onTagsClick}
            data-modal-trigger="true"
        />
        <MoreActionsItem
            key="details"
            label={t`Подробнее`}
            icon={<MoreDetailed/>}
            onClick={onDetailsClick}
        />
        {onLogClick && (
            <MoreActionsItem
                key="log"
                label={t`Журнал`}
                icon={<Journal/>}
                onClick={onLogClick}
            />
        )}
        <MoreActionsItem
            key="trash"
            label={t`Удалить`}
            icon={<Delete/>}
            onClick={onDeleteClick}
            data-modal-trigger="true"
        />
    </MoreActionsDots>
);

export default React.memo(MonitorMenu);
